import { Form, FormFieldType } from "@/forms/Form";

export class DocumentForm extends Form {
  protected definition = {
    name: { type: FormFieldType.Text, required: true }
  };
}
